<template>
  <div class="usersMultiselectComp">

    <multiselect
      v-model="dataSelected"
      id="ajax"
      label="phone"
      track-by="code"
      placeholder="Type to search"
      open-direction=""
      :options="data"
      :multiple="true"
      :searchable="true"
      :loading="false"
      :internal-search="false"
      :clear-on-select="false"
      :close-on-select="false"
      :options-limit="300"
      :limit="3"
      :limit-text="limitText"
      :max-height="600"
      :show-no-results="false"
      :hide-selected="true"
      @search-change="getAll"
    >
      <!-- <template
        slot="tag"
        slot-scope="{ option, remove }"
      >
        <span class="custom__tag">
          <span>{{ option.phone }}</span>
          <span class="custom__remove" @click="remove(option)">❌</span>
        </span>
      </template> -->
      <!-- <template slot="clear" slot-scope="props">
        <div class="multiselect__clear" v-if="dataSelected.length" @mousedown.prevent.stop="clearAll(props.search)"></div>
      </template> -->
      <span slot="noResult">Ничего не найдено</span>
    </multiselect>

  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'multiselectComp',
  props: {
    options: Array
  },
  data: function () {
    return {
      value: [],
      moduleName: 'users',
      data: [],
      dataSelected: []
    }
  },
  created: function () {
  },
  mounted () {
  },
  components: {
    Multiselect
  },
  computed: {
  },
  watch: {
  },
  methods: {
    limitText (count) {
      return `and ${count} other countries`
    },
    async getAll (searchQuery) {
      await this.$store.dispatch(`${this.moduleName}/getAll`, { params: { search: searchQuery, limit: 10 } })
      let result = this.$store.getters[`${this.moduleName}/getAll`]
      this.data = result.data.data
    },
    clearAll () {
      this.data = []
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">

.usersMultiselectComp {
  position: relative;
}
.btn_all {
  position: absolute;
  z-index: 500;
  background-color: #ff8200;
  border-radius: 50%;
  border: none;
  color: #ffffff;
  width: 22px;
  height: 22px;
  top: calc(50% - 14px);
  right: 35px;
}
.btn_reset {
  position: absolute;
  z-index: 500;
  background-color: #ff8200;
  border-radius: 50%;
  border: none;
  color: #ffffff;
  width: 22px;
  height: 22px;
  top: calc(50% - 14px);
  right: 65px;
}
button:hover, button:active {
  opacity: 0.5;
}
.multiselect--active {
  z-index: 5000;
}
</style>
